// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1HNCp","left":"StickyBox_left__1kU6A","right":"StickyBox_right__9LxSH"};